var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCaretDownSolid = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    focusable: "false",
    x: "0px",
    y: "0px",
    viewBox: "0 0 320 512",
    style: {
      enableBackground: "new 0 0 320 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3,119h257.3c17.8,0,26.7,38,14.1,60.3L174.1,406.7c-7.8,13.8-20.5,13.8-28.3,0L17.2,179.3C4.6,157,13.5,119,31.3,119z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCaretDownSolid, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/caret-down-solid.92a1ec3f.svg";
export { ForwardRef as ReactComponent };